import 'rc-slider/assets/index.css';

import React from 'react';
import RcSlider from 'rc-slider';

export default (props) => <RcSlider {...props}  />
